export const environment = {
  production: false,
  staging: false,
  dev: false,
  siteUrl: 'https://myportal-sandbox.business.comcast.com',
  apiUrl: 'https://myportal-sandbox.business.comcast.com/api/v2',
  mocks: false,
  iscUrl: 'https://isc.dev.masergy.com?kc_idp_hint=comcast-idbroker',
  oktaClientId: '0oa2dri9y2z2whs8B0h8',
  oktaIssuer:
    'https://login-dev.business.comcast.com/oauth2/auspfww55tWNlx5O20h7',
};
